import { Tab } from '@headlessui/react'
import React from 'react'

import {
  Response_WorkDetailCreator,
  Response_WorkDetailEpisode,
} from '@/api/@types'
import { Tag } from '@/components/common/DataDisplay'
import { ToggleButton } from '@/components/common/General'

import { ActorAndCreator } from './ActorAndCreator'
import { WorkEpisode } from './WorkEpisode'
import { WorkRelationship } from './WorkRelationship'
import { WorkStory } from './WorkStory'

export type WorkTabPanelProps = {
  episodes: Response_WorkDetailEpisode[] | undefined
  creators: Response_WorkDetailCreator[] | undefined
  description: string
  waitFreeCount: number
  introImageUrl: string
}

export const WorkTabPanel = ({
  episodes,
  creators,
  description,
  waitFreeCount,
  introImageUrl,
}: WorkTabPanelProps) => {
  const [isOpenDetail, setIsOpenDetail] = React.useState(false)

  const handleClickToggleButton = () => setIsOpenDetail(isOpen => !isOpen)

  return (
    <Tab.Panel className="pt-16 pb-32">
      <div className="flex justify-between py-8">
        <div className="space-y-8">
          <p className="font-bold font-xs">
            全{episodes?.length ?? 0}エピソード配信中
          </p>
          <div className="flex space-x-4">
            <Tag variantColor={'waitFree'}>待つと無料</Tag>
            <span className="font-bold font-xs">{waitFreeCount}話分</span>
          </div>
        </div>
        <div>
          <ToggleButton
            isOpen={isOpenDetail}
            onClick={handleClickToggleButton}
            className="text-2xs"
          >
            作品詳細
          </ToggleButton>
        </div>
      </div>
      {isOpenDetail && (
        <div className="py-16">
          <ActorAndCreator creators={creators} />
          <WorkStory story={description} />
          <WorkRelationship url={introImageUrl} />
        </div>
      )}
      <WorkEpisode episodes={episodes} />
    </Tab.Panel>
  )
}
